import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import useCompanyContext from '~/hooks/company-scope.hook';
import { useCreateSiteMutation } from '~/schema';
import capitalize from '~/utils/string';
import Icon from '~/components/common/icon.component';
import SiteForm, { SiteValues } from '~/components/sites/site-form.component';

interface CreateSiteProps {
  onSiteCreated: () => void;
  onCancel: () => void;
}

const CreateSite = ({ onSiteCreated, onCancel }: CreateSiteProps) => {
  const [error, setError] = useState(null);
  const { t } = useTranslation();
  const { company } = useCompanyContext();

  const [createSite] = useCreateSiteMutation();

  const handleSubmit = async (values: SiteValues) => {
    setError(null);
    const { data: createSiteResult, errors: createErrors } = await createSite({
      variables: {
        site: {
          name: values.name,
          address: values.address,
          postcode: values.postcode,
          city: values.city,
          isHeadquarters: values.isHeadquarters,
          country: values.country.toLocaleLowerCase(),
          companyId: company?.id,
        },
      },
    });

    if (!createSiteResult.createSite.success || createErrors) {
      setError(
        createErrors?.[0]?.message ||
          t('Er liep iets fout bij het opslaan. Probeer het later opnieuw.'),
      );
      return;
    }

    onSiteCreated();
  };

  return (
    <div className="flex flex-col items-center w-full justify-center">
      <div className="p-2 border-2 border-black rounded-full mb-4">
        <Icon className="w-8" name="OfficeBuildingIcon" />
      </div>
      <p className="text-2xl text-center mb-4">
        {capitalize(t('voeg een nieuwe'))}{' '}
        <span className=" font-bold">{t('site')}</span> {t('toe')}
      </p>
      <SiteForm onSubmit={handleSubmit} onCancel={onCancel} error={error} />
    </div>
  );
};

export default CreateSite;
